import React from "react";
import { tierFor } from "@/lib/utils-app";

export function ScoreGauge({ score = 0, size = 180, stroke = 12, label = true }) {
  const tier = tierFor(score);
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="hsl(var(--muted))"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={tier.ring}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display font-black tabular tracking-tight" style={{ fontSize: size / 3.6 }}>
          {score}
        </span>
        {label && <span className="overline text-muted-foreground mt-1">/ 100</span>}
      </div>
    </div>
  );
}
